export default __webpack_public_path__ + "static/media/jpg.807bae30.svg";